var render = function render(){var _vm=this,_c=_vm._self._c;return _c('IdfStandardInputs',{attrs:{"label":_vm.$t('ctx.discount.listing.search')}},[_c('IdfInput',{attrs:{"iconLeft":"search","placeholder":_vm.$t('ctx.discount.listing.search-placeholder')},model:{value:(_vm.keyWord),callback:function ($$v) {_vm.keyWord=$$v},expression:"keyWord"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }